import type { ActionApi, SearchMode } from '../../../../common/types/index.tsx';
import { checkIsSupportedSearchScope } from '../../../../common/utils/index.tsx';
import { setLocalSearchMode } from '../../../../common/utils/storage.tsx';

export const setSearchMode =
	(newSearchMode: SearchMode): ActionApi =>
	async ({ setState }, { searchScope }) => {
		const { objectTypeId } = checkIsSupportedSearchScope(searchScope);
		setState({
			searchMode: newSearchMode,
		});
		setLocalSearchMode(objectTypeId, newSearchMode);
	};
